module.exports = new __parcel__URL__("Charlie_Text-Regular.c1cc34af.woff2").toString();